module.exports = __webpack_public_path__ + "static/media/4.21023ca5.jpg";